/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Field_KeyInputs */

const en_byoa_field_key = /** @type {(inputs: Byoa_Field_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI key`)
};

const id_byoa_field_key = /** @type {(inputs: Byoa_Field_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci AI`)
};

/**
* | output |
* | --- |
* | "AI key" |
*
* @param {Byoa_Field_KeyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_field_key = /** @type {((inputs?: Byoa_Field_KeyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Field_KeyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_field_key(inputs)
	return en_byoa_field_key(inputs)
});